import { render, staticRenderFns } from "./HowTherapyUnfolds.vue?vue&type=template&id=c4fcc58a&scoped=true"
import script from "./HowTherapyUnfolds.vue?vue&type=script&lang=js"
export * from "./HowTherapyUnfolds.vue?vue&type=script&lang=js"
import style0 from "./HowTherapyUnfolds.vue?vue&type=style&index=0&id=c4fcc58a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fcc58a",
  null
  
)

export default component.exports